import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Analytics configuration - placeholders for GA4, Meta Pixel, TikTok Pixel
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '';
const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || '';

export const AnalyticsProvider = ({ children }) => {
  const location = useLocation();

  // Initialize analytics on mount
  useEffect(() => {
    // Google Analytics 4 initialization
    if (GA_MEASUREMENT_ID) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID);
    }

    // Meta Pixel initialization
    if (META_PIXEL_ID) {
      !function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
      }(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
    }

    // TikTok Pixel initialization
    if (TIKTOK_PIXEL_ID) {
      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=i;ttq._t=ttq._t||{};ttq._t[e]=+new Date;ttq._o=ttq._o||{};ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript";o.async=!0;o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
        ttq.load(TIKTOK_PIXEL_ID);
        ttq.page();
      }(window, document, 'ttq');
    }
  }, []);

  // Track page views on route change
  useEffect(() => {
    // GA4 page view
    if (window.gtag && GA_MEASUREMENT_ID) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }

    // Meta Pixel page view
    if (window.fbq && META_PIXEL_ID) {
      window.fbq('track', 'PageView');
    }

    // TikTok Pixel page view
    if (window.ttq && TIKTOK_PIXEL_ID) {
      window.ttq.page();
    }
  }, [location]);

  return children;
};

// Analytics helper functions
export const trackEvent = (eventName, params = {}) => {
  // GA4
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }

  // Meta Pixel
  if (window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }

  // TikTok
  if (window.ttq) {
    window.ttq.track(eventName, params);
  }
};

export const trackLead = (leadType = 'general') => {
  trackEvent('generate_lead', { lead_type: leadType });
  
  if (window.fbq) {
    window.fbq('track', 'Lead', { content_name: leadType });
  }
};

export const trackContactForm = (formType) => {
  trackEvent('submit_contact_form', { form_type: formType });
  
  if (window.fbq) {
    window.fbq('track', 'Contact', { content_name: formType });
  }
};

export default AnalyticsProvider;
